import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PopUp from 'components/PopUp';
import ReversibleButton from 'components/reversible-button';
import ReactDOM from 'react-dom';

interface SubscriptionExpiredPopupProps {
  isVisible: boolean;
  onLogout: () => void;
  isAdmin?: boolean;
  onDismiss?: () => void;
}

const SubscriptionExpiredPopup: React.FC<SubscriptionExpiredPopupProps> = ({
  isVisible,
  onLogout,
  isAdmin = false,
  onDismiss,
}) => {
  const { t } = useTranslation();
  const storedUser = localStorage.getItem('user');
  
  const message = isAdmin 
    ? t('sentences:popup.messages.subscriptionExpiredAdmin')
    : (storedUser ? t('sentences:popup.messages.subscriptionExpiredNotAdmin'): t('sentences:popup.messages.subscriptionExpired'));

  const handleLogout = () => {
    onLogout();
    if (onDismiss) {
      onDismiss();
    }
  };

  useEffect(() => {
    // Cleanup function to remove the popup from DOM when component unmounts
    return () => {
      const root = document.getElementById('subscription-expired-popup-root');
      if (root) {
        ReactDOM.unmountComponentAtNode(root);
        root.remove();
      }
    };
  }, []);

  return (
    <PopUp
      isVisible={isVisible}
      title={message}
      description={''}
      onDismiss={onDismiss}
      actionButtons={[
        <ReversibleButton onClick={handleLogout}>
          {t('verbs.logout')}
        </ReversibleButton>,
      ]}
    />
  );
};

export default SubscriptionExpiredPopup; 